import Login from "@/views/Login.vue";
import { Subject } from "rxjs";
import { toRefs } from "vue";

export default class LoginService {
    private static store: any = null;

    public static LOGIN_SUBJECT: Subject<any> = new Subject();

    private static cacheTime = 0;

    public static getLoginSubject(): Subject<any> {
        const store = LoginService.getStore();
        const {currentParkInfo} = toRefs(store.state);

        if (currentParkInfo.value.id !== undefined) {
            LoginService.sendSuccessInfo();
        }
        return LoginService.LOGIN_SUBJECT;
    }

    public static sendSuccessInfo() {
        let current = new Date().getTime();
        if (current - this.cacheTime > 50) {
            this.cacheTime = current;
        } else {
            return;
        }

        setTimeout(() => {
            //console.log("send success info!");
            LoginService.LOGIN_SUBJECT.next("success");
        }, 50);
    }

    private static getStore() {
        return LoginService.store;
    }

    static initStore(store: any) {
        this.store = store;
    }

    static parkChooseCallback(func: any) {
        const store = LoginService.getStore();
        if (store == null) {
            setTimeout(() => {
                LoginService.parkChooseCallback(func);
            }, 300);
            return;
        }
        const {currentParkInfo} = store.state;
        //console.log(currentParkInfo);
        if (currentParkInfo !== undefined) {
            func();
            return;
        }
        //
        let interval = setInterval(() => {
            if (currentParkInfo !== undefined) {
                func();
                clearInterval(interval);
            }
        }, 500, 500);
    }
}
